module.exports = __webpack_public_path__ + "static/media/hero-squares-mb.3bad050b.png";